/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatCal = require('../types/NatCal')
const Ope = require('../types/Ope')
const CCalculAncetre = require('./CCalculAncetre')
const CCbGlob = require('../kernel/CCbGlob')
module.exports = CTestEqNatOp

/**
 * Test d'équivalence de nature d'opérateur.
 * Renvoie true sseulement si les deux calxuls ont le même opérateur principal
 * (par exemple un test d'égalité).
 * @constructor
 * @extends CCalculAncetre
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {String} nomCalcul : Le nom du calcul.
 * @param {CCalcul} calcul1 : Le premier calcul testé (peut être aussi une fonction).
 * @param {CCalcul} calcul2 : Le deuxième calcul testé (peut être aussi une fonction).
 * @returns {CTestEqNatOp}
 */
function CTestEqNatOp (listeProprietaire, impProto, estElementFinal, nomCalcul,
    calcul1, calcul2) {
  if (arguments.length === 1) CCalculAncetre.call(this, listeProprietaire);
  else {
    if (arguments.length === 3) CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal);
    else {
      CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
      this.calcul1 = calcul1;
      this.calcul2 = calcul2;
    }
  }
  this.existe = true;
  this.dejaPositionne = false;
}
CTestEqNatOp.prototype = new CCalculAncetre();
CTestEqNatOp.prototype.constructor = CTestEqNatOp;
CTestEqNatOp.prototype.superClass = "CCalculAncetre";
CTestEqNatOp.prototype.className = "CTestEqNatOp";

CTestEqNatOp.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.impProto);
  var ind2 = listeSource.indexOf(this.calcul1);
  var ind3 = listeSource.indexOf(this.calcul2);
  return new CTestEqNatOp(listeCible, listeCible.get(ind1, "CImplementationProto"),
    this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CCalcul"), listeCible.get(ind3, "CCalcul"));
};
CTestEqNatOp.prototype.getNatureCalcul = function() {
  return NatCal.NTestNatureOperateur;
};
CTestEqNatOp.prototype.rendValeur = function() {
  return this.resultat;
};
CTestEqNatOp.prototype.positionne = function(infoRandom, dimfen) {
  if (!this.dejaPositionne) {
    this.metAJour();
    this.dejaPositionne = true;
  }
};
CTestEqNatOp.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CCalculAncetre.prototype.dependDe.call(this, p) || this.calcul1.dependDe(p) || this.calcul2.dependDe(p));
};
CTestEqNatOp.prototype.dependDePourBoucle = function(p) {
  return (p === this) || this.calcul1.dependDePourBoucle(p) || this.calcul2.dependDePourBoucle(p);
};
CTestEqNatOp.prototype.metAJour = function() {
  this.dejaPositionne = true;
  if (this.verifieEquivalenceNature()) {
    this.resultat = 1;
  }
  else this.resultat = 0;
};
CTestEqNatOp.prototype.verifieEquivalenceNature = function() {
  if ((this.calcul1.calcul.className === "CMoinsUnaire") || (this.calcul2.calcul.className === "CMoinsUnaire")) {
    var cb1 = this.calcul1.calcul.className === "CMoinsUnaire" ? this.calcul1.calcul.operande : this.calcul1.calcul;
    var cb2 = this.calcul2.calcul.className === "CMoinsUnaire" ? this.calcul2.calcul.operande : this.calcul2.calcul;
    if ((cb1.nature() === CCbGlob.natOperation)  && (cb2.nature() === CCbGlob.natOperation)) {
      if (((cb1.Ope=== Ope.Mult) && (cb2.Ope === Ope.Mult))
          || ((cb1.Ope === Ope.Divi ) && (cb2.Ope === Ope.Divi))) return true;
    }
  }
  if (this.calcul1.calcul.className !== this.calcul2.calcul.className) return false;
  // Les deux calculs sont de même classe
  if (this.calcul1.calcul.nature() === CCbGlob.natOperation) {
    var op1 = this.calcul1.calcul;
    var op2 = this.calcul2.calcul;
    if (op1.Ope === Ope.Egalite) return (op2.Ope === Ope.Egalite);
    if ((op1.Ope === Ope.Sup) || (op1.Ope === Ope.Inf))
      return ((op2.Ope === Ope.Sup) || (op2.Ope === Ope.Inf));
    if ((op1.Ope === Ope.SupOuEgal) || (op1.Ope === Ope.InfOuEgal))
      return ((op2.Ope === Ope.SupOuEgal) || (op2.Ope === Ope.InfOuEgal));
    return (op1.Ope === op2.Ope);
  }
  else return true;
};
CTestEqNatOp.prototype.read = function(inps, list){
  CCalculAncetre.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.calcul1 = list.get(ind1,"CCalcul");
  var ind2 = inps.readInt();
  this.calcul2 = list.get(ind2,"CCalcul");
};
CTestEqNatOp.prototype.write = function(oups, list){
  CCalculAncetre.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.calcul1);
  oups.writeInt(ind1);
  var ind2 = list.indexOf(this.calcul2);
  oups.writeInt(ind2);
};



// WEBPACK FOOTER //
// ./src/objets/CTestEqNatOp.js